import { Box, Stack, Typography } from '@mui/material'

const CompleteBox = ({ title, bgColor, point = 0 }) => {
    // Extract numeric value from point string (e.g., '75%' -> 75)
    const clampedValue = Math.min(Math.max(point, 0), 100)

    return (
        <Stack width="110px" alignItems={'center'} justifyContent={'center'} gap={'8px'}>
            <Typography
                variant="h6"
                color="rgba(56, 66, 80, 1)"
                fontFamily={'Poppins'}
                fontSize={'14px'}
                fontWeight={400}
                textAlign={'center'}
                lineHeight={'1'}>
                {title}
            </Typography>
            <Stack
                width="110px"
                height="44px"
                bgcolor="rgba(240, 240, 240, 1)"
                borderRadius="7px"
                position="relative"
                overflow="hidden"
                alignItems={'center'}
                justifyContent={'center'}>
                {/* Progress Fill */}
                <Box
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: `${clampedValue}%`,
                        backgroundColor: bgColor,
                        borderRadius: clampedValue >= 100 ? '7px' : '7px 0 0 7px',
                        transition: 'width 0.3s ease'
                    }}
                />
                {/* Text */}
                {point >= 0 && (
                    <Typography
                        variant="h6"
                        color="rgba(0, 0, 0, 1)"
                        fontFamily={'Inter'}
                        fontSize={'16px'}
                        fontWeight={400}
                        textAlign={'center'}
                        lineHeight={'1'}
                        position="relative"
                        zIndex={1}>
                        {point} %
                    </Typography>
                )}
            </Stack>
        </Stack>
    )
}

export default CompleteBox
